module.exports = __webpack_public_path__ + "img/schema_corset_1c.81999056.svg";